


  <div class="chart">
    <canvas id="myChart" #barChart>{{chart}}</canvas>
  </div>